<template>
  <div>
    <!--单校团体训练报告-->
    <train-set ref="secondSet" />

    <div v-if="!view" style="text-align: right; margin: 30px 0; padding-right: 50px">
      <a-button @click="$parent.$data.current = 0" style="margin-right: 20px">上一步</a-button>
      <a-button type="primary" @click="next">下一步</a-button>
    </div>
  </div>
</template>

<script>
import TrainSet from '../components/TrainSet.vue'

export default {
  name: 'StepsSecond',
  inject: {
    view: { default: false }
  },
  components: {
    TrainSet
  },
  data() {
    return {
      boxSpinning: false,
    }
  },
  methods: {
    next() {
      if (!Object.keys(this.$refs.secondSet.primaryData).length) {
        return this.$message.error('请添加训练课程')
      }
      if (this.$refs.secondSet.primaryData.configuredClassStudentCount <= 0) {
        return this.$message.error('请配置班级')
      }
      this.$store.commit('organization/setReportInfo', {
        ...this.$store.getters['organization/getReportInfo'],
        courseName: this.$refs.secondSet.primaryData.courseName,
        organizationName: this.$refs.secondSet.primaryData.organizationName,
      })
      this.$parent.$data.current = 2
    }
  },
}
</script>

<style scoped></style>
